// The promotion editor saves #RRGGBBAA, including transparent colors.
// Resolve contrast against the card's light page background, not just the RGB.
export const promotionTextColor = (background) => {
  let hex = String(background || "").replace(/^#/, "");
  if (/^[\da-f]{3,4}$/i.test(hex)) {
    hex = hex.split("").map((character) => character + character).join("");
  }
  if (!/^[\da-f]{6}([\da-f]{2})?$/i.test(hex)) return "#202936";
  const alpha = hex.length === 8 ? parseInt(hex.slice(6), 16) / 255 : 1;
  const channels = [0, 2, 4].map((offset) => {
    const color = (parseInt(hex.slice(offset, offset + 2), 16) * alpha + 255 * (1 - alpha)) / 255;
    return color <= 0.04045 ? color / 12.92 : Math.pow((color + 0.055) / 1.055, 2.4);
  });
  const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  return luminance > 0.179 ? "#000000" : "#ffffff";
};
